module.exports = __webpack_public_path__ + "img/btn_cancel3_2recruit.4c9c4132.png";